import { render, staticRenderFns } from "./DropdownSegment.vue?vue&type=template&id=36b45700"
import script from "./DropdownSegment.vue?vue&type=script&lang=js"
export * from "./DropdownSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports